import Breadcrumbs from './breadcrumbs';
import Container from './container';
import LazyImage from './lazy-image';
import React, { useCallback, useState } from 'react';
import Title from './title';
import WipeAnimation from './wipe-animation';
import mq from '../utils/mq';
import styled, { css } from 'styled-components';
import { Box, Flex, Paragraph } from './UIKit/system';
import { VideoPlayer } from './video-player';
import { darkBackground } from '../utils/styles';
import { vw } from '../utils/size-functions';

const IMAGE_OFFSET = 390;
const IMAGE_OFFSET_TABLET = 280;
const IMAGE_OFFSET_MOBILE = 240;

const StyledIntro3 = styled(Box)`
  ${darkBackground};
  margin-bottom: ${IMAGE_OFFSET}px;

  ${mq.tablet(css`
    margin-bottom: ${IMAGE_OFFSET_TABLET}px;
  `)};
  ${mq.mobile(css`
    margin-bottom: ${IMAGE_OFFSET_TABLET}px;
  `)};
  ${mq.mobileLarge(css`
    margin-bottom: ${IMAGE_OFFSET_TABLET}px;
  `)};

  @media (max-width: 425px) {
    margin-bottom: ${IMAGE_OFFSET_MOBILE}px;
  }
`;

const Image = styled(LazyImage)`
  position: absolute !important;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  position: relative;
`;

const StyledParagraph = styled(Paragraph)`
  max-width: 722px;
  text-wrap: balance;
  color: #c4c4c4;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: -0.36px;
`;

const Pretext = styled.p`
  color: #c4c4c4;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 160%;
  letter-spacing: -0.15px;
  margin-bottom: 8px;
`;

function Intro3WithVideo({
  pagination,
  pretext,
  title,
  text,
  image,
  video,
  autoPlay = false
}) {
  return (
    <StyledIntro3 pt={[80, 100, 125]}>
      <Container>
        <Flex flexDirection={'column'} alignItems={'center'} mb={88}>
          {pretext && <Pretext>{pretext}</Pretext>}
          {!pretext && <Breadcrumbs mb={20} items={pagination} white />}
          <Title
            as={'h1'}
            maxWidth={650}
            mb={15}
            textAlign={'center'}
            html={title}
          />
          <StyledParagraph lightGrey textAlign={'center'} html={text} />
        </Flex>
        <WipeAnimation
          mt={[-IMAGE_OFFSET_MOBILE, -IMAGE_OFFSET_TABLET, -IMAGE_OFFSET]}
          bottom={[-IMAGE_OFFSET_MOBILE, -IMAGE_OFFSET_TABLET, -IMAGE_OFFSET]}
          width={'100%'}
          height={[IMAGE_OFFSET_MOBILE, IMAGE_OFFSET_TABLET, vw(580)]}
          threshold={0}
          maxHeight={video ? 600 : undefined}
        >
          {image && <Image fluid={image} />}
          {video && (
            <VideoPlayer videoSource={video.filename} autoPlay={autoPlay} />
          )}
        </WipeAnimation>
      </Container>
    </StyledIntro3>
  );
}

export default Intro3WithVideo;
